import { Injectable } from '@angular/core';

import { PaymentMethod, PaymentToken, RidangoReduxAction, ShoppingCart } from '@ridango/core';
import { CartStatus } from '../../../lib/purchase/purchase.model';

@Injectable()
export class PaymentMethodsActions {
    static FETCH_START = '[Payment-Methods]: Fetch start';
    static FETCH_START_WITH_EPIC = '[Payment-Methods]: Fetch start WE';
    static FETCH_SUCCESS = '[Payment-Methods]: Fetch success';
    static FETCH_FAILED = '[Payment-Methods]: Fetch failed';
    static FETCH_END = '[Payment-Methods]: Fetch end';

    static SET_SELECTED = '[Payment-Methods]: Set selected payment method';
    static SET_SELECTED_METHOD_PIN = '[Payment-Methods]: Set selected payment method pin';

    static CLEAR = '[Payment-Methods]: Clear';

    static SET_ALL_ACCOUNT_METHODS = '[Payment-Methods]: Set account methods';
    static SET_SELECTED_ACCOUNT_METHOD = '[Payment-Methods]: Set selected account method';

    static FETCH_ADYEN_SESSION = '[Payment-Methods]: Fetch Adyen session';
    static FETCH_ADYEN_SESSION_SUCCESS = '[Payment-Methods]: Fetch Adyen session success';
    static FETCH_ADYEN_SESSION_FAILED = '[Payment-Methods]: Fetch Adyen session failed';

    static FETCH_ADYEN_PAYMENT_STATUS = '[Payment-Methods]: Fetch Adyen payment status';
    static FETCH_ADYEN_PAYMENT_STATUS_SUCCESS = '[Payment-Methods]: Fetch Adyen payment status success';
    static FETCH_ADYEN_PAYMENT_STATUS_FAILED = '[Payment-Methods]:Fetch Adyen payment status failed';
    static SET_CART_STATUS = '[Payment-Methods]:Set cart status';
    static SET_CART_REDIRECT_URL = '[Payment-Methods]:Set cart redirect url';

    fetchStart(): RidangoReduxAction {
        return {
            type: PaymentMethodsActions.FETCH_START
        };
    }

    fetchStartWithEpic(cart: ShoppingCart): RidangoReduxAction {
        return {
            type: PaymentMethodsActions.FETCH_START_WITH_EPIC,
            payload: cart
        };
    }

    fetchSuccess(payload: any): RidangoReduxAction {
        return {
            type: PaymentMethodsActions.FETCH_SUCCESS,
            payload: payload
        };
    }

    fetchFailed(payload): RidangoReduxAction {
        return {
            type: PaymentMethodsActions.FETCH_FAILED
        };
    }

    fetchEnd(): RidangoReduxAction {
        return {
            type: PaymentMethodsActions.FETCH_END
        };
    }

    setSelected(payload: PaymentMethod): RidangoReduxAction {
        return {
            type: PaymentMethodsActions.SET_SELECTED,
            payload: payload
        };
    }

    clear(): RidangoReduxAction {
        return {
            type: PaymentMethodsActions.CLEAR
        };
    }

    setSelectedMethodPin(pin: any): RidangoReduxAction {
        return {
            type: PaymentMethodsActions.SET_SELECTED_METHOD_PIN,
            payload: { pin: pin }
        };
    }

    setAllAccountPaymentMethods(methods: PaymentToken[]): RidangoReduxAction {
        return {
            type: PaymentMethodsActions.SET_ALL_ACCOUNT_METHODS,
            payload: methods
        };
    }

    setSelectedAccountPaymentMethod(method: PaymentToken): RidangoReduxAction {
        return {
            type: PaymentMethodsActions.SET_SELECTED_ACCOUNT_METHOD,
            payload: method
        };
    }

    fetchAdyenSession(shoppingCartId: number, lang: string, returnUrl: string): RidangoReduxAction {
        return {
            type: PaymentMethodsActions.FETCH_ADYEN_SESSION,
            payload: {
                shoppingCartId: shoppingCartId,
                lang: lang,
                returnUrl: returnUrl
            }
        };
    }

    fetchAdyenSessionSuccess(payload): RidangoReduxAction {
        return {
            type: PaymentMethodsActions.FETCH_ADYEN_SESSION_SUCCESS,
            payload: payload
        };
    }

    fetchAdyenSessionFailed(error): RidangoReduxAction {
        return {
            type: PaymentMethodsActions.FETCH_ADYEN_SESSION_FAILED,
            payload: error
        };
    }

    fetchAdyenPaymentStatus(token: string): RidangoReduxAction {
        return {
            type: PaymentMethodsActions.FETCH_ADYEN_PAYMENT_STATUS,
            payload: token
        };
    }

    fetchAdyenPaymentStatusSuccess(response): RidangoReduxAction {
        return {
            type: PaymentMethodsActions.FETCH_ADYEN_PAYMENT_STATUS_SUCCESS,
            payload: response
        };
    }

    fetchAdyenPaymentStatusFailed(error: Error): RidangoReduxAction {
        return {
            type: PaymentMethodsActions.FETCH_ADYEN_PAYMENT_STATUS_FAILED,
            payload: error
        };
    }

    setCartStatus(status: CartStatus): RidangoReduxAction {
        return {
            type: PaymentMethodsActions.SET_CART_STATUS,
            payload: status
        };
    }

    setCartRedirectUrl(status: string): RidangoReduxAction {
        return {
            type: PaymentMethodsActions.SET_CART_REDIRECT_URL,
            payload: status
        };
    }
}
